<template>
    <Paper class='achievements--monthly-assess-score'>
        <el-radio-group v-model="radio">
            <el-radio v-for="(item, index) in radioOptions" :label="item.value" :key="index">{{ item.label }}</el-radio>
        </el-radio-group>
        <div v-for="(item, index) in radioOptions" :key="index">
            <ScorePanel v-show="radio === item.value" ref="panelRef" :businessType="item.value" :isCurrentPanel="radio === item.value"></ScorePanel>
        </div>
    </Paper>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api';
import Paper from '@/components/core/paper/Paper';
import ScorePanel from './ScorePanel.vue';

export default {
    components: { Paper, ScorePanel },
    data() {
        return {
            radioOptions: [],
            radio: null
        };
    },
    mounted() {
        dictWithUrl('SRM_ASSESSMENT_BUSYNESS_TYPE').then(res => {
            if (res && +res.code === 0) {
                this.radioOptions = Object.keys(res.data.SRM_ASSESSMENT_BUSYNESS_TYPE).map(key => {
                    return {
                        label: res.data.SRM_ASSESSMENT_BUSYNESS_TYPE[key],
                        value: key
                    };
                });
                this.radio = this.radioOptions.length ? this.radioOptions[0].value : null;
            }
        });
    }
};
</script>
<style lang="less">
.achievements--monthly-assess-score {
    .el-radio-group {
        margin-bottom: 10px;
    }
    #mPane3 .el-table {
        min-height: calc(100vh - 194px);
    }
}
</style>
